import {Polygon} from '../../../schemas';

export default (polygonData) => {
  return new Polygon({
    d:    polygonData.path,
    // This is according the decompiled swf files.
    isGA: polygonData.action && polygonData.action.substr(0, 2) === 'ga'
  });
};



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/decoders/polygon_decoder.js